import React, { Component } from 'react'
import Survey from './img/Survey.jpg'



const FactTwo = () => {
  return (
    <div>
    <img src={Survey} alt="Survey" className='comp-img' />
  <h3 className='par'>The Survey Corps</h3>
  <p className='par'>Now, for the most important group of people in the series: the Survey Corps, also known as the Scouting Legion.  They're super important, considering the fact that they protect the walls of the city (Wall Maria, the outer wall, Wall Rose, the middle wall, and Wall Sina, the innermost wall) from the Titans!  The Scouting Legion not only looks to recruit fresh blood when they return home from their expeditions, but they go out and fight the Titans head-on, as they try to uncover their mystery and history.  They do everything in their power to stop the Titans from advancing through the city walls.</p>
  </div>
  )
}

export default FactTwo